/**
 * Imported first by every entry point. Zod probes for eval with Function('')
 * on its first parse; our CSP blocks eval, so the probe only produces a console
 * CSP report. Turning the JIT off skips the probe. This must run before any
 * module parses a schema at load time, hence its own module, imported first.
 */
import { config } from 'zod';

config({ jitless: true });
